import useSceneStore from '../store/useSceneStore';
import usePreferencesStore from '../store/usePreferencesStore';
import useFurnitureStore from '../store/useFurnitureStore';
import useStyleStore from '../store/useStyleStore';
import useShapeStore from '../store/useShapeStore';

export const applyStyle = (styleId) => {
  const styleStore = useStyleStore.getState();
  const style = styleStore.styles.find(s => s.id === styleId);
  if (!style) return;

  // 1. Update Preferences (for new objects)
  const prefStore = usePreferencesStore.getState();
  prefStore.setWallColor(style.walls.color);
  prefStore.setWallThickness(style.walls.thickness);
  prefStore.setRoomFillColor(style.rooms.fillColor);
  if (style.rooms.fillOpacity !== undefined) {
    prefStore.setRoomFillOpacity(style.rooms.fillOpacity);
  }
  
  // Save object style preferences for future new items
  prefStore.setObjectStrokeColor(style.objects.stroke);
  prefStore.setObjectFillColor(style.objects.fill);

  // 2. Update Existing Scene Elements
  const sceneStore = useSceneStore.getState();
  const { walls, rooms } = sceneStore;
  
  // Update Walls
  const newWalls = { ...walls };
  Object.keys(newWalls).forEach(id => {
      newWalls[id] = { 
          ...newWalls[id], 
          color: style.walls.color, 
          thickness: style.walls.thickness 
      };
  });

  // Update Rooms
  const newRooms = { ...rooms };
  Object.keys(newRooms).forEach(id => {
      newRooms[id] = {
          ...newRooms[id],
          fillColor: style.rooms.fillColor,
          fillOpacity: style.rooms.fillOpacity
      };
  });
  
  // NOTE: Elements (Doors/Windows) are explicitly EXCLUDED from style updates per user request.
  // They retain their default or individually set colors.

  // Update Furniture (including Stairs and Compasses)
  const furnitureStore = useFurnitureStore.getState();
  const { furnitureItems, updateFurnitureItem } = furnitureStore;
  
  Object.keys(furnitureItems).forEach(id => {
      updateFurnitureItem(id, {
          strokeColor: style.objects.stroke,
          fillColor: style.objects.fill
      });
  });

  // Update Shapes (Basic Shapes and Arrows)
  const shapeStore = useShapeStore.getState();
  const { shapeItems } = shapeStore;
  
  const newShapeItems = { ...shapeItems };
  Object.keys(newShapeItems).forEach(id => {
      newShapeItems[id] = {
          ...newShapeItems[id],
          customStroke: style.objects.stroke,
          customFill: style.objects.fill
      };
  });
  useShapeStore.setState({ shapeItems: newShapeItems });

  // Commit updates to scene (only walls and rooms)
  useSceneStore.setState({ walls: newWalls, rooms: newRooms });
  
  // Set active style
  styleStore.setActiveStyleId(styleId);
};